import { CheckCircle2 } from "lucide-react";

const features = [
    "Certified, trained mechanics",
    "OEM-grade parts & 12-month warranty",
    "Diagnostic scan tools for all makes",
    "Flat-rate pricing — quote before work begins",
    "Digital invoice with repair photos",
    "Insurance & fleet accounts welcome",
];

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="border-b hairline"
        >
            <div className="mx-auto max-w-[1400px] grid grid-cols-12">
                <div className="col-span-12 lg:col-span-5 border-r hairline">
                    <img
                        src="/images/about-mechanic.png"
                        alt="Certified mobile mechanic performing an oil change"
                        className="w-full h-full object-cover min-h-[360px]"
                    />
                </div>
                <div className="col-span-12 lg:col-span-7 px-6 md:px-12 py-14 md:py-20">
                    <div className="font-mono-tech text-[11px] text-[#1d4ed8] mb-6 flex items-center gap-3 flex-wrap">
                        <span>ABOUT</span>
                        <span
                            data-testid="about-black-owned-badge"
                            className="inline-flex items-center gap-1.5 bg-[#0a0a0a] text-white px-2.5 py-1 font-mono-tech text-[10px] tracking-[0.16em]"
                        >
                            <span className="w-1.5 h-1.5 bg-[#1d4ed8] rounded-full" />
                            BLACK-OWNED · DENVER METRO
                        </span>
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl leading-[0.95] tracking-tighter max-w-xl">
                        Built on word-of-mouth.
                        <br />
                        Backed by certifications.
                    </h2>
                    <p className="text-[#52525b] mt-6 leading-relaxed max-w-2xl">
                        Quiseo Auto Repair LLC is a fully-mobile shop that puts
                        the customer relationship first. Every job comes with a
                        written estimate, transparent labor hours, photos of
                        what we replaced, and a written warranty. We don&apos;t
                        upsell — we explain.
                    </p>

                    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 border-t border-l hairline">
                        {features.map((f) => (
                            <div
                                key={f}
                                data-testid={`about-feature-${f}`}
                                className="border-r border-b hairline p-5 flex items-start gap-3"
                            >
                                <CheckCircle2
                                    className="w-5 h-5 text-[#1d4ed8] mt-0.5 shrink-0"
                                    strokeWidth={1.5}
                                />
                                <span className="text-sm md:text-[15px] leading-snug">
                                    {f}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
